<template>
  <v-app v-touch="{
    left: () => removeOverflow(),
  }">
    <div id="app-child">
      <div :class="[
        !isMobile && hasToken && !isContactUs ? 'page-wrap' : 'page-wrap2',
      ]" style="display: flow-root">
        <app-header-detail v-if="!isContactUs && !(isMobile && isIndex)" />

        <!-- <app-notification v-if="hasToken && !isContactUs" /> -->

        <div class="router" :style="[
          !isContactUs ? { top: '60px' } : { top: 0 },
          isContactUs
            ? { backgroundColor: 'white' }
            : { backgroundColor: '#e8e8e8' },
        ]">
          <router-view />
          <v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout">
            {{ snackbar.text }}
          </v-snackbar>
          <div class="progressParent" v-if="progress">
            <div class="progress">
              لطفا منتظر بمانید
              <v-progress-circular indeterminate> </v-progress-circular>
            </div>
          </div>
        </div>
      </div>
      <app-slider v-if="!isContactUs && !isMobile" v-touch="{
        right: () => addOverflow(),
      }" ref="slider" :hasToken="hasToken" :slideIsOpen="slideIsOpen" :isMobile="isMobile" @closeSlider="addOverflow"
        @openSlider="removeOverflow" />
    </div>
  </v-app>
</template>

<script>
import Vue from "vue";
import Header from "@/components/Header";
import HeaderDetail from "@/components/HeaderDetail";
import Slider from "@/views/slider/Index";
import { widthChanged, monitorFocus } from "@/utils/constants";
import { getToken } from "@/utils/auth";
import Notification from "@/components/Notification";

export default {
  name: "App",
  components: {
    appHeader: Header,
    appHeaderDetail: HeaderDetail,
    appSlider: Slider,
    appNotification: Notification,
  },
  computed: {

    snackbar() {
      return this.$store.getters.snackbar;
    },
    progress() {
      return this.$store.getters.progress;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    hasToken() {
      return this.$store.getters.token != "" && getToken();
    },
    threshold() {
      return this.isMobile ? 130 : 300;
    },
  },
  data() {
    return {
      slideIsOpen: false,
      isContactUs: true,
      isIndex: false,
    };
  },
  created() {
    this.isIndex = this.$route.path.toLowerCase() == "/index";
  },
  methods: {
    removeOverflow() {
      // if (this.isMobile && !this.slideIsOpen && this.hasToken) {
      //   document.querySelector("html").style.overflow = "hidden";
      //   this.slideIsOpen = true;
      // }
    },
    addOverflow() {
      // if (this.isMobile && this.slideIsOpen && this.hasToken) {
      //   document.querySelector("html").style.overflow = "auto";
      //   this.slideIsOpen = false;
      // }
    },
    setSlideisOpen(isMobile, hasToken) {
      this.slideIsOpen = !isMobile && hasToken;
    },
  },

  mounted() {
    this.setSlideisOpen(this.isMobile, this.hasToken);
  },
  watch: {
    isMobile(value) {
      this.setSlideisOpen(value, this.hasToken);
    },
    hasToken(value) {
      this.setSlideisOpen(this.isMobile, value);
    },
    $route(to, from) {
      var title = "طلوع";

      this.isContactUs = to.path.toLowerCase() == "/contactus";
      this.isIndex = to.path.toLowerCase() == "/index";

      switch (to.path) {
        case "/messages":
          title = "پیام ها";
          break;
        case "/cycles":
          title = "کارنامه دوره ها";
          break;
        case "/payeh":
          title = "وضعیت پایه ها";
          break;
        case "/open-cycles":
          title = "انتخاب درس";
          break;
        case "/hozoor":
          title = "لیست کلاس ها";
          break;
        case "/khorooj-request":
          title = "درخواست خروج از کشور";
          break;
        case "/khorooj-index":
          title = "خروج از کشور و سربازی";
          break;
        case "/khorooj-history":
          title = "سوابق خروج از کشور";
          break;
        case "/khorooj-last":
          title = "اعلام وضعیت سفر";
          break;
        case "/transfer-qom":
          title = "انتقال به قم و استان های تابعه";
          break;
        case "/transfer-ostan":
          title = "انتقالات درون استان";
          break;
        case "/salary":
          title = "امور مالی و شهریه";
          break;
        case "/home-request-history":
          title = "سوابق اجاره و ضمانت";
          break;
        case "/registers":
          title = "ثبت نام ها";
          break;
        case "/registers-history":
          title = "مشاهده سوابق ثبت نام";
          break;
        case "/ezam":
          title = "اعزام مبلغ";
          break;
        case "/ezam-history":
          title = "اعزام ها";
          break;
          case "/ezamrequest":
          title = "درخواست تبلیغ";
          break;
        case "/ezamrequest-history":
          title = "سوابق درخواست تبلیغ";
          break;
        case "/jazb":
          title = "طرح ها";
          break;
        case "/jazb-history":
          title = "مشاهده سوابق جذب";
          break;
        case "/links":
          title = "لینک های مفید";
          break;
        case "/noor":
          title = "طرح نور";
          break;
        case "/contacts":
          title = "مشاهده پیام های ارسال شده";
          break;
        case "/new-contact":
        case "/new-contact-v2":
          title = "درخواست‌ها و ارتباط با ما";
          break;
        case "/madrak":
          title = "مدرک تحصیلی";
          break;
        case "/madrak-request":
          title = "درخواست مدرک تحصیلی";
          break;
        case "/madrak-history":
          title = "سوابق درخواست مدرک تحصیلی";
          break;
        case "/tadris-request":
          title = "درخواست تدریس";
          break;
        case "/marital-request":
          title = "درخواست تغییر وضعیت تاهل";
          break;
        case "/marital-history":
          title = "سوابق وضعیت تاهل";
          break;
        case "/morkhasi-request":
          title = "درخواست مرخصی";
          break;
        case "/morkhasi-history":
          title = "سوابق درخواست مرخصی";
          break;
        case "/tahsil-request":
          title = "درخواست تحصیل همزمان";
          break;
        case "/tahsil-history":
          title = "سوابق درخواست تحصیل همزمان";
          break;
        case "/tadris-permission-request":
          title = "درخواست مجوز تدریس";
          break;
        case "/tadris-permission-history":
          title = "سوابق مجوز تدریس";
          break;
        case "/delete-course-request":
          title = "درخواست حذف درس";
          break;
        case "/delete-course-history":
          title = "سوابق حذف درس";
          break;
        case "/change-picture-request":
          title = "درخواست تغییر تصویر";
          break;
        case "/change-picture-history":
          title = "سوابق تغییر تصویر";
          break;
        case "/home-request-active":
          title = "کمک هزینه مسکن";
          break;
        case "/resume":
          title = "رزومه";
          break;
        case "/aboutus":
          title = "آشنایی با حوزه";
          break;
        case "/exams":
          title = "کارت ورود به جلسه";
          break;
        case "/shafahi":
          title = "امتحان شفاهی";
          break;
        case "/poll":
          title = "نظرسنجی";
          break;
        case "/discussion":
          title = "مباحثات";
          break;
        case "/transfer-request":
          title = "درخواست انتقال";
          break;
        case "/ejare-new":
          title = "درخواست کمک هزینه اجاره مسکن";
          break;
        case "/buy-new":
          title = "درخواست کمک هزینه خرید مسکن";
          break;
        case "/eteraz":
          title = "اعتراض به نمره";
          break;
        case "/gheibat":

          title = "غیبت های کلاسی";
          break;
        case "/gheibatSingle":
          title = " حضور و غیاب";
          break;
        case "/talabbos-request":
        case "/talabbos-index":
        case "/talabbos-history":
          title = "گواهی تلبس";
          break;
        case "/amrieh":
          title = "درخواست امریه";
          break;
        case "/discussion":
          title = "مباحثات";
          break;
        case "/aboutus/majors":
          title = "رشته های تخصصی";
          break;
        case "/aboutus/ayinnamehs":
          title = "آیین نامه ها";
          break;
        case "/aboutus/schools":
          title = "معرفی مدارس";
          break;
      }
      this.$store.commit("SET_HEADER_TITLE", title);
    },
    $mobile(value) {
      this.$store.commit("SET_MOBILE", value);
    },
  },
  created() {
    widthChanged();
    monitorFocus();
    this.$store.commit("SET_NUM_SYSTEM", "");
    this.$store.commit("SET_FULLNAME", "");
    this.$store.commit("SET_AVATAR", "");
    this.$store.commit("SET_UNREAD_MESSAGE_COUNT", 0);
    this.$store.commit("SET_USERINFO", {});

    if (this.hasToken) {
      //  this.$store.dispatch("GetUserInfo");
    }
  },
};
</script>
<style>
:root {
  --colorPrimary: #3366cc;
  --colorSecondary: #4625b22a;
  --colorHeader: #0156ad;
  --colorSlider: #003470;
  --colorVertical: #ff3300;
  --colorSecondary2: #ff6600;
  --colorConfirm: #ffcc99;
}


.colorSlider {
  background-color: var(--colorSlider) !important;
}

.colorHeader {
  background-color: var(--colorHeader) !important;
}

.mazaya {
  background-color: var(--colorSecondary);
  color: black;
}

.kosoorat {
  background-color: var(--colorSecondary2);
}

.userinfo {
  display: flex;
  background-color: var(--colorPrimary);
  border: 1px;
  border-radius: 15px 15px 0px 0px;
  color: white;
}

#app {
  font-family: "vazir", sans-serif;
  background-color: white;
  direction: rtl;
}

#app-child {
  padding-bottom: 20px;
}

.router {
  position: relative;
  padding: 1px;

  min-height: calc(100vh - 60px);
}

h1 {
  text-align: center;
}

@font-face {
  font-family: vazir;
  src: url("./assets/fonts/vazir/Vazir-Regular-FD.woff");
  font-weight: 300;
  font-display: swap;
}

.v-card__title {
  border: 1px;
  border-radius: 15px 15px 0px 0px;
  text-align: justify;
  white-space: pre-line;
  font-size: 1rem !important;
  word-break: normal !important;
}

.form .v-card__title {
  color: var(--colorPrimary);
}

.form .v-card .v-card__title {
  color: white;
}

.text-center {
  margin: auto;
}

.text-black {
  color: black;
}

.text-padding {
  padding-right: 20px;
}

.info-title {
  background-color: var(--colorPrimary);
  color: white;
  margin-bottom: 15px;
}

.info-detail {
  background-color: var(--colorSecondary);
  color: black !important;
  margin-bottom: 15px;
}

.student-detail {
  background-color: var(--colorPrimary);
}

.v-card {
  border-radius: 15px !important;
  border: 1px;
  margin: 15px;
  white-space: pre-line;
}

.parent {
  z-index: 2;
  background-color: transparent !important;
  display: flow-root;
}

@media only screen and (min-width: 1000px) {
  .parent-2 {
    width: 50%;
    float: right;
  }
}

/* @media only screen and (min-width: 1500px) {
  .parent-2 {
    width: 33%;
  }
} */

@media only screen and (min-width: 2000px) {
  .parent-2 {
    width: 25%;
  }
}

.collapse {
  margin: 5px 5px 0 5px;
  position: absolute;
  cursor: pointer;
}

.courses {
  width: 100%;
  position: absolute;
  z-index: 1;

  padding-bottom: 50px;
}

.v-btn,
.v-tab {
  letter-spacing: 0 !important;
}

.v-tabs-items {
  min-height: calc(100vh - 140px) !important;
  overflow-y: auto !important;
}

.v-input--switch {
  direction: ltr !important;
  margin-top: 10px !important;
  padding-top: 0px !important;
}

.v-messages__message {
  display: none;
}

.v-input__slot {
  margin-bottom: 0px !important;
  height: unset;
}

.v-label {
  direction: ltr !important;
  margin-right: 3px !important;
  display: unset !important;
  text-align: right;
  color: black !important;
}

.confirm {
  position: fixed;
  bottom: 0px;
  width: 100%;
  background-color: var(--colorConfirm);

  z-index: 1;
}

.register {
  max-width: 200px !important;
  float: left;
  margin: 10px 20px;
  width: 30%;
}

.btnMargin {
  margin: 10px 20px 10px 310px !important;
}

.v-data-table {
  margin: 15px 15px !important;
}

.v-data-table-header {
  background-color: var(--colorPrimary);
}

.v-dialog {
  text-align: center;
  overflow-y: unset !important;
  overflow-x: auto !important;
  box-shadow: unset !important;
}

.green-row {
  background-color: rgba(0, 255, 0, 0.5) !important;
}

.red-row {
  background-color: rgba(255, 0, 0, 0.5) !important;
}

.changed-row {
  background-color: #00d10040 !important;
}

.v-snack {
  margin-bottom: 70px;
  z-index: 10000 !important;
}

.v-snack__wrapper {
  border-radius: 25px !important;
}

.v-snack__content {
  text-align: center !important;
}

.ltr {
  direction: ltr;
}

.halfPage {
  width: 50%;
  float: right;
}

.v-data-table__wrapper>table>thead>tr>th {
  color: white !important;
}

.table-notFound {
  margin: 10px 20px;
}

.form-center {
  width: 100%;
}

.form,
.fullForm {
  padding: 20px;
}

.v-file-input .v-label {
  right: 0px !important;
  left: unset !important;
}

.showInput input {
  text-align: right;
  color: white !important;
}

.child thead {
  background-color: var(--colorSecondary);
}

.child .v-data-table__wrapper>table>thead>tr>th {
  color: black !important;
}

.child th.sortable>.mdi:before {
  color: black !important;
}

.page-wrap {
  margin-right: 300px;
  transition: 0.5s ease;

  transition-property: margin-right;
}

.page-wrap2 {
  margin-right: 0px;
  transition: 0.5s ease;

  transition-property: margin-right;
}

.v-data-table__empty-wrapper {
  color: black !important;
}

.table-title {
  text-align: center;
  margin-top: 15px;
}

.no-expand .v-data-table__expand-icon {
  display: none !important;
}

.right-side {
  width: 30px;
  float: right;
  background-color: var(--colorVertical);

  border-radius: 0px 15px 15px 0px !important;
  text-align: center;
}

.left-side {
  border-radius: 15px 0px 0px 15px !important;
  float: right;
  width: calc(100% - 30px);
}

.rotated {
  color: white;
  transform: rotate(90deg);
}

.mdi-chevron-left::before {
  content: "\F0142";
}

.mdi-chevron-right::before {
  content: "\F0141";
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.fullText {
  text-align: justify;

  white-space: pre-line;
  word-break: normal !important;
}

.content {
  background-color: var(--colorSecondary);
  margin: 0 10px;
  border-radius: 15px;
  color: black !important;
}

th.sortable>.mdi:before {
  color: white !important;
}

th.sortable>.mdi {
  display: none;
}

th.sortable:hover>.mdi {
  display: inline-flex;
}

th.sortable.active>.mdi {
  display: inline-flex;
}

a.innerLink {
  direction: ltr;
  display: block;
  color: var(--colorPrimary) !important;
  text-decoration: underline;
}

.v-application ul,
.v-application ol {
  padding-right: 24px !important;
  padding-left: unset !important;
}

.col-12 span {
  text-align: justify;
}

.v-data-table__expand-icon {
  width: 35px;
  height: 35px;
}

.v-data-table-header-mobile__wrapper .v-select__slot .v-label {
  right: 0px !important;
  left: auto !important;
  color: white !important;
}

.v-data-table-header-mobile__wrapper .v-select__selections {
  margin-top: 10px;
}

.container {
  border: 2px solid #ccc;
  padding: 0 !important;
}

.selected {
  background-color: bisque !important;
}

.rounded tr:hover.selected {
  background-color: bisque !important;
}

.rounded tr:hover {
  background-color: transparent !important;
}

.no-first thead th:first-child {
  display: none;
}

.no-first tbody tr td:first-child {
  display: none;
}

.v-card__text {
  text-align: justify;
  color: black !important;
}

.bm-overlay {
  background-color: whitesmoke;
}

.addBtn {
  position: fixed;
  bottom: 30px;
  left: 30px;

  z-index: 1;
}

.progress {
  position: relative;
  text-align: center;
  background-color: #333;
  color: white;
  border-radius: 25px;
  padding: 8px;
  width: 200px;
  margin: 0 auto;
}

.progressParent {
  position: fixed;
  z-index: 1000;
  font-size: 0.875rem;
  left: 0;
  width: 100%;
  bottom: 78px;
}

.v-progress-circular {
  margin-right: 8px;
}

.btn-menus {
  width: 100% !important;
  height: 90px !important;
  border-radius: 7px;
  padding: 0px !important;
  box-shadow: 0px 0px 7px 1px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #a8aaaa;
}

.menus {
  padding: 20px;

  background-color: #e8e8e8;
}

.menuTitle {
  width: 100%;
  display: block;
  position: relative;
  top: 10px;
  padding: 4px 0;
  border-radius: 0 0 6px 6px;
  font-size: 0.875em;
  white-space: pre-line;
}

.menuIcon {
  text-align: center;
  top: 5px;
  position: relative;
}

.menus .v-btn__content {
  flex: unset;
  display: block;
  width: 100%;
}

.menuCol {
  padding: 5px 5px 10px 5px !important;
}

.divider {
  text-align: center;
  display: flex;
  align-items: center;
  padding: 20px 30px;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
}

.divider:not(:empty)::before {
  margin-left: 10px;
  border-radius: 0 20px 20px 0;
}

.divider:not(:empty)::after {
  margin-right: 10px;
  border-radius: 20px 0 0 20px;
}

.dchild {
  margin: 0 10%;
}

.dparent::before,
.dparent::after {
  border-bottom: 32px solid lightgreen;
}

.dchild::before,
.dchild::after {
  border-bottom: 5px solid orangered;
}

.fixedPosition {
  background-color: white;
  position: fixed;
  left: 0px;
  z-index: 2;
}

.v-textarea.v-text-field {
  height: 100% !important;
  width: 100%;
}

.v-text-field {
  height: 24px !important;
  top: -5px !important;
  padding-top: 0px !important;
  margin-top: 0px !important;
  width: 100%;
}

.myDialog {
  max-width: 500px;
  padding: 50px 30px 20px 10px;
  background-color: white;
}

.dialogButton {
  border-radius: 4px;
  margin: 5px;
  height: 32px !important;
  border-style: solid;
  border-width: 1px;
  border-color: gray !important;
  font-size: 13px !important;
  width: 100px;
  max-width: 30%;
}

.valueButton {
  float: left;
  margin-right: 20px;
}

.hr-with-text {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;
}

.hr-with-text::before,
.hr-with-text::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #000;
}

.hr-with-text:not(:empty)::before {
  margin-left: 0.5em;
}

.hr-with-text:not(:empty)::after {
  margin-right: 0.5em;
}
</style>
